export default {"src":"/_next/static/media/disponibility.640c1015.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};